const PAYMENT_ALERT_PREFIX = "alert";

export const PAYMENT_ALERT_TEST_IDS = {
    HEADER: `${PAYMENT_ALERT_PREFIX}_header`,
    HEADER_ICON: `${PAYMENT_ALERT_PREFIX}_header_icon`,
    HEADER_TITLE: `${PAYMENT_ALERT_PREFIX}_header_title`,
    HEADER_MESSAGE: `${PAYMENT_ALERT_PREFIX}_header_msg`,
    CONTENT: `${PAYMENT_ALERT_PREFIX}_content`,
    ALERT_INFO: `${PAYMENT_ALERT_PREFIX}_info`,
    ALERT_SUB_INFO: `${PAYMENT_ALERT_PREFIX}_subinfo`,
    PRIMARY_ACTION_BUTTON: `${PAYMENT_ALERT_PREFIX}_primary_btn`,
    SECONDARY_ACTION_BUTTON: `${PAYMENT_ALERT_PREFIX}_sec_btn`,
    CLOSE_ICON: `${PAYMENT_ALERT_PREFIX}_close_icon`,
};
